import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

// Material components
import {
    Paper,
} from '@material-ui/core';


const useStyles = makeStyles({
    paper: {
        padding: '10px',
        marginLeft: '40px'
    },
});

export function DetailsRowLogOperations(props) {

    const classes = useStyles();

    return (
        <Paper className={classes.paper} variant="outlined">
            {props.row.DesOperation}
        </Paper>
    );
}